import { validationLength } from "../components/actions/validations";

const textMax = validationLength.roomFeatureName;
const longTextMax = validationLength.reservationGuestNotesText;

const spaceRule = (max: number) =>
  `Max ${max} characters; letters, numbers and spaces only; no special characters.`;

const nameRule = (max: number) =>
  `Max ${max} characters; line breaks not allowed.`;

const digitsRule = `Digits only; max ${textMax} characters.`;

/** Default (non-error) helper text under Reserve Activities fields. */
export const reserveActivitiesFieldHelperText = {
  activityCode: `${spaceRule(textMax)} Mandatory.`,
  activityName: `${spaceRule(textMax)} Mandatory.`,
  activityType:
    "Select Group lesson, Private lesson, or Open booking. Optional.",
  classType: "Select By session, By class, or By duration. Optional.",
  activityDescription: `${nameRule(longTextMax)} Optional.`,
  activityCategory: `${spaceRule(textMax)} Optional.`,
  activitySubCategory: `${spaceRule(textMax)} Optional.`,
  minGroupSize: `${digitsRule} Optional.`,
  maxGroupSize: `${digitsRule} Optional.`,
  minActivityStrength: `${nameRule(textMax)} Optional.`,
  maxActivityStrength: `${nameRule(textMax)} Optional.`,
  maxStandbyStrength: `${digitsRule} Optional.`,
  autoConfirmStandby:
    "Select Yes or No for auto-confirmation of standby after cancellation. Optional.",
  guestType: `${spaceRule(textMax)} Optional.`,
  guestTypePricing: `${nameRule(textMax)} Optional.`,
  membershipType: `${spaceRule(textMax)} Optional.`,
  membershipPricing: `${nameRule(textMax)} Optional.`,
  startDate: "Select the first active date. Optional.",
  endDate: "Select the last active date. Optional.",
  startTime: "Select the daily start time. Optional.",
  endTime: "Select the daily end time. Optional.",
  numberOfLocations: `${digitsRule} Optional.`,
  locationName: `${spaceRule(textMax)} Optional.`,
  staffGuide: `${spaceRule(textMax)} Optional.`,
  requirePrepayment: "Select Yes or No for prepayment requirement. Optional.",
  paymentType: `${spaceRule(textMax)} Optional.`,
  basePrice: "Select a base price from Rate Plan. Optional.",
  cancellationFeeRequired: `${nameRule(longTextMax)} Optional.`,
  cancellationFeeType:
    "Select Percentage or Flat Amount for the cancellation fee. Optional.",
  cancellationDeadline: `${nameRule(textMax)} Optional.`,
  cancellationPolicyDescription: `${nameRule(longTextMax)} Optional.`,
  activityImage: `${nameRule(textMax)} Optional.`,
  reservationParameter: `${nameRule(textMax)} Optional.`,
  addonsName: `${nameRule(textMax)} Optional.`,
  checkInCutoffMinutes: `${digitsRule} Optional.`,
} as const;

/** Error helper text (shown in red when field validation fails). */
export const reserveActivitiesFieldErrors = {
  required: "This field is required.",
  activityCode: spaceRule(textMax),
  activityName: spaceRule(textMax),
  activityDescription: nameRule(longTextMax),
  activityCategory: spaceRule(textMax),
  activitySubCategory: spaceRule(textMax),
  minGroupSize: digitsRule,
  maxGroupSize: digitsRule,
  minActivityStrength: nameRule(textMax),
  maxActivityStrength: nameRule(textMax),
  maxStandbyStrength: digitsRule,
  guestType: spaceRule(textMax),
  guestTypePricing: nameRule(textMax),
  membershipType: spaceRule(textMax),
  membershipPricing: nameRule(textMax),
  numberOfLocations: digitsRule,
  locationName: spaceRule(textMax),
  staffGuide: spaceRule(textMax),
  paymentType: spaceRule(textMax),
  cancellationFeeRequired: nameRule(longTextMax),
  cancellationDeadline: nameRule(textMax),
  cancellationPolicyDescription: nameRule(longTextMax),
  activityImage: nameRule(textMax),
  reservationParameter: nameRule(textMax),
  addonsName: nameRule(textMax),
  checkInCutoffMinutes: digitsRule,
} as const;
